_N_E =
(window["webpackJsonp_N_E"] = window["webpackJsonp_N_E"] || []).push([[26],{

/***/ "G3+f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("o0o1");
/* harmony import */ var _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("HaE+");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__("nKUr");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__("mOvS");
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _grandvision_analytics__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__("PM6f");
/* harmony import */ var _grandvision_api_client__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__("Dott");
/* harmony import */ var _grandvision_bloomreach__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__("cIxt");
/* harmony import */ var _grandvision_elements__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__("m5xE");
/* harmony import */ var _grandvision_stores__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__("KOn7");
/* harmony import */ var _grandvision_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__("B4sh");
/* harmony import */ var _util_format_address__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__("ekGo");
/* harmony import */ var _util_feature_toggle__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__("ns9e");















var _getConfig = next_config__WEBPACK_IMPORTED_MODULE_4___default()(),
    publicRuntimeConfig = _getConfig.publicRuntimeConfig;

var apiUrls = publicRuntimeConfig.grandvision.endpoints || {};
var selfUrl = publicRuntimeConfig.selfUrl || '';

var StoresPage = function StoresPage(_ref) {
  var stores = _ref.stores,
      _ref$queryParams = _ref.queryParams,
      queryParams = _ref$queryParams === void 0 ? {} : _ref$queryParams;

  var _useBloomreachPageRou = Object(_grandvision_bloomreach__WEBPACK_IMPORTED_MODULE_7__[/* useBloomreachPageRoutes */ "n"])(),
      routes = _useBloomreachPageRou.routes;

  var pageUrl = selfUrl + routes.stores;
  var bookAppointmentUrl = _grandvision_stores__WEBPACK_IMPORTED_MODULE_9__[/* Util */ "f"].getBookAppointmentUrl(routes['book-appointment'] || '');

  var storeDetailUrl = function storeDetailUrl(store) {
    return "".concat(routes['stores'], "/").concat(Object(_grandvision_utils__WEBPACK_IMPORTED_MODULE_10__[/* slugify */ "E"])(store.town), "/").concat(store.slug);
  };

  return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__["jsx"])(_grandvision_bloomreach__WEBPACK_IMPORTED_MODULE_7__[/* CmsContainerPage */ "d"], {
    children: /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__["jsxs"])(_grandvision_bloomreach__WEBPACK_IMPORTED_MODULE_7__[/* CmsPageLayout */ "g"], {
      children: [/*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__["jsx"])(_grandvision_bloomreach__WEBPACK_IMPORTED_MODULE_7__[/* CmsComponentSlot */ "c"], {
        path: "main/top-container"
      }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__["jsx"])(_grandvision_elements__WEBPACK_IMPORTED_MODULE_8__[/* Container */ "d"], {
        className: "stores-layout",
        children: /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__["jsx"])(_grandvision_stores__WEBPACK_IMPORTED_MODULE_9__[/* StoreFinder */ "d"], {
          emailHidden: true,
          phoneHidden: true,
          stores: stores,
          initialValue: (queryParams === null || queryParams === void 0 ? void 0 : queryParams.search) || '',
          getBookAppointmentUrl: bookAppointmentUrl,
          getStoreDetailUrl: storeDetailUrl,
          showUseMyLocation: Object(_util_feature_toggle__WEBPACK_IMPORTED_MODULE_12__[/* isGPSEnabled */ "g"])(),
          searchType: _grandvision_stores__WEBPACK_IMPORTED_MODULE_9__[/* SearchType */ "b"].Location,
          addressFormatter: _util_format_address__WEBPACK_IMPORTED_MODULE_11__[/* default */ "a"]
        })
      }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__["jsx"])(_grandvision_bloomreach__WEBPACK_IMPORTED_MODULE_7__[/* CmsComponentSlot */ "c"], {
        path: "main/bottom-container"
      }), stores.length > 0 && /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__["jsx"])(_grandvision_analytics__WEBPACK_IMPORTED_MODULE_5__[/* Stores */ "l"], {
        url: pageUrl,
        stores: stores
      })]
    })
  });
};

StoresPage.getInitialProps = /*#__PURE__*/function () {
  var _ref3 = Object(_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_1__[/* default */ "a"])( /*#__PURE__*/_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.mark(function _callee(_ref2) {
    var req, stores;
    return _babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_0___default.a.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            req = _ref2.req;
            stores = [];
            _context.prev = 2;
            _context.next = 5;
            return _grandvision_api_client__WEBPACK_IMPORTED_MODULE_6__[/* Stores */ "i"].list(apiUrls.stores);

          case 5:
            stores = _context.sent;
            _context.next = 11;
            break;

          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](2);
            console.error("StoresPage: Failed to fetch stores for url: ".concat(apiUrls.stores), _context.t0);

          case 11:
            return _context.abrupt("return", {
              stores: stores,
              queryParams: req.query
            });

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[2, 8]]);
  }));

  return function (_x) {
    return _ref3.apply(this, arguments);
  };
}();

/* harmony default export */ __webpack_exports__["default"] = (StoresPage);

/***/ }),

/***/ "Xdxz":
/***/ (function(module, exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/stores",
      function () {
        return __webpack_require__("G3+f");
      }
    ]);
  

/***/ }),

/***/ "ekGo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("nKUr");
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__("q1tI");
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(react__WEBPACK_IMPORTED_MODULE_1__);





var formatAddress = function formatAddress(store) {
  return /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsxs"])(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["Fragment"], {
    children: [/*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])("div", {
      children: store.streetName
    }), store.additionalStreetInfo && /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])("div", {
      children: store.additionalStreetInfo
    }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])("div", {
      children: store.town
    }), /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])("div", {
      children: store.province
    }), store.postalCode && /*#__PURE__*/Object(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__["jsx"])("div", {
      children: store.postalCode
    })]
  });
};

/* harmony default export */ __webpack_exports__["a"] = (formatAddress);

/***/ }),

/***/ "ns9e":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isAABEnabled; });
/* unused harmony export isABTestingEnabled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isAddressBookEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isMyAccountEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return isContactLensEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isContactLensStockEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return isCrossSellEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return isReviewsEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isSolutionsEnabled; });
/* unused harmony export isSearchEnabled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return isVtoEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isGPSEnabled; });
/* unused harmony export isPlacePredictionsEnabled */
/* unused harmony export isMultilingualEnabled */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return isPrescriptionGlassesEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isPrescriptionGlassesConfiguratorValidationStepEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return isPrescriptionFileEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return isStoreSearchEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return isSubscriptionHasOneAddressEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return isSubscriptionUpdateAddressEnabled; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return isCartV2Enabled; });
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__("mOvS");
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_0__);
/**
 * This exposes functions that will return true when a feature toggle has been set.
 * It will work both on the server and client
 *
 * To enable a feature:
 *
 *  1) Find the feature name in the `Feature` type below, for instance 'MYACCOUNT'
 *  2) Set an env var using the FEATURE_ prefix when starting the server, ie FEATURE_MYACCOUNT
 *  3) Run the app with `FEATURE_MYACCOUNT=true yarn serve` in dev mode or you can add it the .env file
 *
 * To add a feature toggle
 *
 *  1) Add a name to the Feature type, AWESOME_SAUCE for example,
 *      ex: `| 'AWESOME_SAUCE'`
 *  2) Export a function named isAwesomeSauceEnabled
 *      ex: `export const isAwesomeSauceEnabled: FeatureCheck = isFeatureEnabled.bind(null, 'AWESOME_SAUCE')`
 *  3) To enable it see above
 */

var enabledFeatures;

var getEnabledFeatures = function getEnabledFeatures() {
  if (!enabledFeatures) {
    enabledFeatures = next_config__WEBPACK_IMPORTED_MODULE_0___default()().publicRuntimeConfig.grandvision.features;

    if (false) {}
  }

  return enabledFeatures;
};

var isFeatureEnabled = function isFeatureEnabled(feature) {
  return getEnabledFeatures().some(function (e) {
    return e.toUpperCase() === feature.toUpperCase();
  });
};

var isAABEnabled = isFeatureEnabled.bind(null, 'AAB');
var isABTestingEnabled = isFeatureEnabled.bind(null, 'ABTESTING');
var isAddressBookEnabled = isFeatureEnabled.bind(null, 'ADDRESSBOOK');
var isMyAccountEnabled = isFeatureEnabled.bind(null, 'MYACCOUNT');
var isContactLensEnabled = isFeatureEnabled.bind(null, 'CONTACTLENS');
var isContactLensStockEnabled = isFeatureEnabled.bind(null, 'CONTACTLENS_STOCK');
var isCrossSellEnabled = isFeatureEnabled.bind(null, 'CROSS_SELL');
var isReviewsEnabled = isFeatureEnabled.bind(null, 'REVIEWS');
var isSolutionsEnabled = isFeatureEnabled.bind(null, 'SOLUTIONS');
var isSearchEnabled = isFeatureEnabled.bind(null, 'SEARCH');
var isVtoEnabled = isFeatureEnabled.bind(null, 'VTO');
var isGPSEnabled = isFeatureEnabled.bind(null, 'GPS_STORES');
var isPlacePredictionsEnabled = isFeatureEnabled.bind(null, 'STORES_PLACE_PREDICTIONS');
var isMultilingualEnabled = isFeatureEnabled.bind(null, 'MULTILINGUAL');
var isPrescriptionGlassesEnabled = isFeatureEnabled.bind(null, 'PRESCRIPTION_GLASSES');
var isPrescriptionGlassesConfiguratorValidationStepEnabled = isFeatureEnabled.bind(null, 'PRESCRIPTION_GLASSES_CONFIGURATOR_VALIDATION_STEP');
var isPrescriptionFileEnabled = isFeatureEnabled.bind(null, 'PRESCRIPTION_FILE');
var isStoreSearchEnabled = isFeatureEnabled.bind(null, 'STORE_SEARCH');
var isSubscriptionHasOneAddressEnabled = isFeatureEnabled.bind(null, 'SUBSCRIPTION_HAS_ONE_ADDRESS');
var isSubscriptionUpdateAddressEnabled = isFeatureEnabled.bind(null, 'SUBSCRIPTION_UPDATE_ADDRESS');
var isCartV2Enabled = isFeatureEnabled.bind(null, 'CART_V2');

/***/ }),

/***/ "yLiY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.setConfig = setConfig;
exports.default = void 0;
var runtimeConfig;

var _default = function _default() {
  return runtimeConfig;
};

exports.default = _default;

function setConfig(configValue) {
  runtimeConfig = configValue;
}

/***/ })

},[["Xdxz",1,2,4,6,5,3,0,8]]]);